


























import { Component, Watch, Mixins, Inject } from 'vue-property-decorator';
import { AxiosInstance } from 'axios';
import {
  LoaderMixin,
  StatusEnum,
  IsChildApprovedMixin,
} from '@/pages/profile/mixins';
import { MentoringHeader, MentoringEmptyTeams } from '@/pages/profile/modules';
import MentoringTeamsList from '../../teamslist';
import Infotext from '@/components/parts/infotext';
import { Button } from '@/pages/profile/components';
import { mentoringService } from '@/services';
import { IMentoringTeams, Child } from './types';

@Component({
  components: {
    Button,
    Infotext,
    MentoringHeader,
    MentoringEmptyTeams,
    MentoringTeamsList,
  },
})
export default class MentoringTeams
  extends Mixins(LoaderMixin, IsChildApprovedMixin)
  implements IMentoringTeams {
  @Inject() $api: AxiosInstance;

  errorMessage: string = '';
  teams: Array<any> = [];

  get isHasTeams(): boolean {
    return this.teams && !!this.teams.length;
  }

  get currentChild(): Child | {} {
    const { id, children } = this;
    const child = children.find((item: any) => id === item.id);
    if (!child) return {};
    return {
      name: child.first_name,
      lastname: child.last_name,
      gender: child.sex,
      photo: child.photo || '',
    };
  }

  get tutoredId(): string {
    return this.id ? this.childTutoredId(this.id) : '';
  }

  @Watch('id', { immediate: true })
  updateData(): void {
    this.reset();
    this.getData();
  }

  closeMessages() {
    this.errorMessage = '';
    this.status = StatusEnum.SUCCESS;
  }

  addRequest(): void {
    this.$router.push({ name: 'profile-newrequests' });
  }

  reset(): void {
    this.teams = [];
    this.closeMessages();
  }

  async getData(): Promise<void> {
    const { $api, tutoredId, isApproved } = this;
    if (!this.isApproved || !tutoredId) return;

    this.status = StatusEnum.LOADING;

    try {
      const { data } = await mentoringService($api).getTeams(tutoredId);
      this.teams = data;
      this.status = StatusEnum.SUCCESS;
    } catch (err) {
      if (err.response.data && err.response.data.errors) {
        const [{ msg }] = err.response.data.errors;
        this.errorMessage = msg;
      }
      this.status = StatusEnum.ERROR;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/views/teams/MentoringTeams.vue